import { useInfiniteQuery } from '@northladder/services';

import { CUSTOMER_SERVICE_API } from '../customerServiceClient';
import { IFetchGradeReviewUrlOptions } from '../types';

/**
 * This is to track the grade review request mutation keys in react query cache.
 */
export const FETCH_GRADE_REVIEW_REQUEST_QUERY =
  'fetch-grade-review-list-query-key';

interface IGradeReviewRequestListQuery {
  queryParams: IFetchGradeReviewUrlOptions;
}

/**
 * This hook will call grade review request list api.
 */
export const useGradeReviewRequestListQuery = ({
  queryParams,
}: IGradeReviewRequestListQuery) => {
  const { appraisalCode, count, fromDate, toDate, status } = queryParams;
  const {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isError,
    isFetching,
    isFetchingNextPage,
    isPending,
    refetch,
  } = useInfiniteQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: [
      FETCH_GRADE_REVIEW_REQUEST_QUERY,
      appraisalCode,
      fromDate,
      toDate,
      status,
    ],
    networkMode: 'always',
    initialPageParam: 1,
    retry: false,
    queryFn: ({ pageParam = 1 }) =>
      CUSTOMER_SERVICE_API.fetchGradeReviewList({
        ...queryParams,
        page: pageParam,
      }),
    getNextPageParam: (lastPage, allPages) => {
      const nextPage = allPages.length + 1;
      const currentCount = allPages.length * count;

      return currentCount < lastPage.count ? nextPage : undefined;
    },
  });

  return {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isError,
    isFetching,
    isFetchingNextPage,
    isPending,
    refetch,
  };
};
